const src = "https://dnnqo5iczq5wf.cloudfront.net/asset/lottie/88431d4746";
export default src;
